export class MissingCognitoUserError extends Error {
  constructor() {
    super('A logged-in Cognito user was not found')
    Object.setPrototypeOf(this, MissingCognitoUserError.prototype)
  }
}
